<simple-notifications></simple-notifications>
<ngx-spinner size = "medium" color = "#fff" type = "ball-clip-rotate-pulse" [fullScreen] = "true"></ngx-spinner>
<router-outlet></router-outlet>
<router-outlet name="list"></router-outlet>
